import React from 'react';
import { useTranslation } from 'react-i18next';

const AppearanceContent = () => {
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language;

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div className="max-w-2xl space-y-8">
      <div className="bg-white rounded-xl border border-grey-200 p-6">
        <div className="mb-5">
          <h2 className="text-lg font-semibold text-grey-900">Language</h2>
          <p className="text-sm text-grey-500 mt-1">Select your preferred language / Seleccione su idioma preferido</p>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <button
            onClick={() => handleLanguageChange('en')}
            className={`flex items-center gap-4 p-4 rounded-xl border-2 transition-all ${
              currentLanguage === 'en' 
                ? 'border-primary-500 bg-primary-50' 
                : 'border-grey-200 bg-grey-50 hover:border-grey-300'
            }`}
          >
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center text-2xl ${
              currentLanguage === 'en' ? 'bg-primary-100' : 'bg-grey-100'
            }`}>
              🇺🇸
            </div>
            <div className="text-left">
              <span className={`text-sm font-semibold block ${currentLanguage === 'en' ? 'text-primary-600' : 'text-grey-700'}`}>
                English
              </span>
              <span className="text-xs text-grey-500">United States</span>
            </div>
            {currentLanguage === 'en' && (
              <svg className="w-5 h-5 text-primary-500 ml-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            )}
          </button>

          <button
            onClick={() => handleLanguageChange('es')}
            className={`flex items-center gap-4 p-4 rounded-xl border-2 transition-all ${
              currentLanguage === 'es' 
                ? 'border-primary-500 bg-primary-50' 
                : 'border-grey-200 bg-grey-50 hover:border-grey-300'
            }`}
          >
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center text-2xl ${
              currentLanguage === 'es' ? 'bg-primary-100' : 'bg-grey-100'
            }`}>
              🇪🇸
            </div>
            <div className="text-left">
              <span className={`text-sm font-semibold block ${currentLanguage === 'es' ? 'text-primary-600' : 'text-grey-700'}`}>
                Español
              </span>
              <span className="text-xs text-grey-500">Spanish</span>
            </div>
            {currentLanguage === 'es' && (
              <svg className="w-5 h-5 text-primary-500 ml-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            )}
          </button>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
        <div className="flex gap-3">
          <svg className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div>
            <h4 className="text-sm font-medium text-blue-800">Settings are saved automatically</h4>
            <p className="text-xs text-blue-700 mt-1">
              Your preferences are stored locally and will be remembered when you return.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppearanceContent;
